import axiosInstance from './axios';

export interface Company {
    id: string;
    nombre: string;
    nit: string;
    direccion?: string;
    telefono?: string;
    email?: string;
    status: 'ACTIVA' | 'INACTIVA' | 'PRUEBA';
    fechaRegistro: string;
    plan?: {
        id: string;
        nombre: string;
    };
    usuarios?: number;
    vehiculos?: number;
    espacios?: number;
    billingEnabled: boolean;
    razonSocial?: string;
    cityId?: string;
    taxRegimeId?: string;
    factusClientId?: string;
    factusClientSecret?: string;
    factusUsername?: string;
    factusPassword?: string;
    expensesEnabled?: boolean;
    expensesOperatorAllowed?: boolean;
    activationCode?: string;
    offlineGraceDays?: number;
    /** Módulo de tienda (lo activa el SUPERADMIN) */
    storeEnabled?: boolean;
    storeOperatorAllowed?: boolean;
    /** Máximo de sedes que puede crear la empresa */
    maxSedes?: number;
    /** Número de sedes creadas */
    sedes?: number;
}

export interface CompanyStats {
    total: number;
    activas: number;
    inactivas: number;
    prueba: number;
}

export interface CreateCompanyData {
    nombre: string;
    nit: string;
    direccion?: string;
    telefono?: string;
    email?: string;
    planId?: string | null;
    billingEnabled?: boolean;
    razonSocial?: string;
    cityId?: string;
    taxRegimeId?: string;
    factusClientId?: string;
    factusClientSecret?: string;
    factusUsername?: string;
    factusPassword?: string;
}

export interface UpdateCompanyData extends Partial<CreateCompanyData> {
    offlineGraceDays?: number;
    status?: 'ACTIVA' | 'INACTIVA' | 'PRUEBA';
    billingEnabled?: boolean;
    razonSocial?: string;
    cityId?: string;
    taxRegimeId?: string;
    factusClientId?: string;
    factusClientSecret?: string;
    factusUsername?: string;
    factusPassword?: string;
    expensesEnabled?: boolean;
    expensesOperatorAllowed?: boolean;
    storeEnabled?: boolean;
    maxSedes?: number;
}

/**
 * Obtener todas las empresas
 */
export const getCompanies = async (): Promise<Company[]> => {
    const response = await axiosInstance.get<Company[]>('/companies');
    return response.data;
};

/**
 * Obtener estadísticas de empresas
 */
export const getCompanyStats = async (): Promise<CompanyStats> => {
    const response = await axiosInstance.get<CompanyStats>('/companies/stats');
    return response.data;
};

/**
 * Obtener una empresa por ID
 */
export const getCompanyById = async (id: string): Promise<Company> => {
    const response = await axiosInstance.get<Company>(`/companies/${id}`);
    return response.data;
};

/**
 * Crear una nueva empresa
 */
export const createCompany = async (data: CreateCompanyData): Promise<Company> => {
    const response = await axiosInstance.post<Company>('/companies', data);
    return response.data;
};

/**
 * Actualizar una empresa
 */
export const updateCompany = async (id: string, data: UpdateCompanyData): Promise<Company> => {
    const response = await axiosInstance.put<Company>(`/companies/${id}`, data);
    return response.data;
};

/**
 * Eliminar una empresa
 */
export const deleteCompany = async (id: string): Promise<{ message: string }> => {
    const response = await axiosInstance.delete<{ message: string }>(`/companies/${id}`);
    return response.data;
};

/**
 * Obtener configuración de la empresa
 */
export const getSettings = async (): Promise<any> => {
    const response = await axiosInstance.get('/companies/settings');
    return response.data;
};

export default {
    getCompanies,
    getCompanyStats,
    getCompanyById,
    createCompany,
    updateCompany,
    deleteCompany,
    getSettings
}